// extracted by mini-css-extract-plugin
export default {"form":"user-info_form__ISN4X","buttonsGroup":"user-info_buttonsGroup__GMwuH","title":"user-info_title__R2-SU text_type_main-medium"};